import { useIsAnalyticsModuleEnabled } from "src/hooks/useIsAnalyticsModuleEnabled";
import { useIsFeatureFlagEnabled } from "src/hooks/useIsFeatureFlagEnabled";
import { FEATURE_FLAGS } from "src/router/featureFlags";

export const useIsWorkspaceInsightsEnabled = (): { isEnabled: boolean } => {
  const isFlagEnabled = useIsFeatureFlagEnabled(
    FEATURE_FLAGS.workspaceInsights,
  );
  const { isEnabled: isAnalyticsModuleEnabled } = useIsAnalyticsModuleEnabled();

  return {
    isEnabled: isFlagEnabled && isAnalyticsModuleEnabled,
  };
};
